import { Box, Button, Card, Chip, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, Input, InputBase, InputLabel, MenuItem, OutlinedInput, Paper, Popover, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Helmet } from 'react-helmet-async'
import { toast } from 'react-toastify';
import Iconify from 'src/components/iconify'
import { getData, postData, putData, uploadFile } from 'src/webService/webService';
import PaginationComponent from 'src/components/pagination';
import { file_URL } from '../../utils/url'

function GraphicDesign() {

    const [open, setOpen] = useState(null);
    const UserId = sessionStorage.getItem("userId");
    const [formOpen, setFormOpen] = useState(false);
    const [dailyData, setDailyData] = useState("");
    const [updatedData, setUpdatedData] = useState({});
    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [selectedLead, setSelectedLead] = useState("");
    const [leadsData, setLeadsData] = useState([]);
    const [view, setView] = useState([]);
    const [allUpdates, setAllUpdates] = useState([]);
    const [scroll, setScroll] = useState('paper');
    const [details, setDetails] = useState(false);
    const descriptionElementRef = useRef(null);
    const [selectedFiles, setSelectedFiles] = useState({})
    const [fileUpload, setFileUpload] = useState(null);
    const [selectedWorkUpdateId, setSelectedWorkUpdateId] = useState(null);
    const [convertForm, setConvertForm] = useState(false);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [openImage, setOpenImage] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [viewMode, setViewMode] = useState('chart');
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    console.log("view", view)

    const [formData, setFormData] = useState({
        projectName: "",
        designType: "",
        colorScheme: "",
        fileFormat: "",
        requirements: "",
        deadline: "",
        status: "",
        comments: "",
        fileUpload: "",
        completionPercentage: "",
        totalDesigns: "",
        completedDesigns: ""
    });

    const [convertData, setConvertData] = useState({
        generalStatus: "",
        serviceName: "",
        assignedUser: "",
        assignedTo: [],
        serviceStatus: "",
        employeeWork: {},
        noOfPosters: [],
        comments: [],
        deadline: [],
        status: []
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setConvertData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleOpenMenu = (event, task, id, workUpdateId) => {
        let lead;

        // If task is the full lead object (Admin/Team Leader case)
        if (task && typeof task === 'object') {
            lead = task;
            setSelectedLead(lead);
        }
        // If task is just the ID (Employee case)
        else {
            lead = leadsData.find((data) => data._id === id);
            setSelectedLead(lead);
        }

        if (event?.currentTarget) {
            setOpen(event.currentTarget);
            setSelectedLeadId(id);
            setSelectedWorkUpdateId(workUpdateId);
            setView(lead || task); // Set view to either the lead object or the task data
        }
    };

    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handleOpenDialog = async () => {
        await getAllUpdatesAdmin();
        setDetails(true);
        handleCloseMenu();
    };

    const handleCloseDialog = () => {
        setDetails(false);
    };

    const handleOpen = async () => {
        setFormOpen(true);
        handleCloseMenu();
    }

    const handleClose = () => {
        setFormOpen(false)
    }

    const handleFormOpen = async () => {
        await getAllUsers();
        setConvertForm(true)
        setOpen(false)
    }

    const handleFormClose = () => {
        setConvertForm(false)
    }

    const handleMultiSelectChange = (event) => {
        const {
            target: { value },
        } = event;
        setConvertData((prev) => ({
            ...prev,
            assignedTo: typeof value === 'string' ? value.split(',') : value,
        }));
    };


    useEffect(() => {
        if (details) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [details]);

    useEffect(() => {
        setUpdatedData({});
    }, [leadsData]);

    const sessionToken = sessionStorage.getItem("Token");
    const role = sessionStorage.getItem("role");
    const roleType = sessionStorage.getItem("roleType");
    const serviceTeamType = sessionStorage.getItem("serviceTeamType");

    const getAllUsers = async () => {
        try {
            const params = { page: 1, limit: 1000 }
            const response = await getData("users/users", params);
            console.log("Response:", response);

            const filteredUsers = response.data.results.filter(user =>
                user.serviceTeamType && user.serviceTeamType.includes("Graphic Designing")
            );

            const formattedOptions = filteredUsers.map(user => ({
                id: user._id,
                name: user.name
            }));

            setEmployeeOptions(formattedOptions);

        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error("Failed to load users");
        }
    };

    const convertLeads = async () => {
        debugger;
        try {
            const params = {
                serviceName: ["Graphic Designing"],
                assignedTo: convertData.assignedTo,
                employeeWork: convertData.employeeWork,
                serviceStatus: "In Progress",
                noOfPosters: convertData.noOfPosters,
                deadline: convertData.deadline,
                comments: convertData.comments,
                status: convertData.status
            };

            const response = await putData(`leads/lead/${selectedLeadId}/status`, params, sessionToken);

            if (response.status === 200) {
                setConvertForm(false);
                toast.success("Lead assigned successfully!");
            } else {
                toast.error("Failed to assign lead.");
            }
        } catch (error) {
            console.error("Error assigning lead:", error);
            toast.error("Something went wrong while assigning the lead.");
        }
    };

    const fetchAssignedLeads = async () => {
        try {
            let response;
            let graphicDesigningLeads = [];

            if (role === "Admin" || roleType === "Team Leader") {
                const params = { page: currentPage, limit: limit, serviceName: "Graphic Designing" }
                response = await getData("leads/services", params, sessionToken);
                console.log("Admin Response", response);
                graphicDesigningLeads = response.data.results[0].paginatedResults;
                const totalRecords = response.data.results[0].totalCount;
                setTotalPages(response.data.results[0].totalPages);
                setTotalCount(totalRecords);

            } else if (roleType === "Employee") {
                const params = {
                    page: currentPage,
                    limit: limit
                };

                const endpoint = `leads/leads/${UserId}`;

                response = await getData(endpoint, params, sessionToken);
                console.log(`${roleType} Response`, response);

                if (roleType === "Employee" && response?.data) {
                    const leadsData = Array.isArray(response.data)
                        ? response.data[0]?.paginatedResults
                        : response.data[0]?.paginatedResults || [];

                    graphicDesigningLeads = leadsData
                    const totalRecords = response.data[0].totalCount.totalItems;
                    setTotalPages(response.data[0].totalPages === null ? 0 : response.data[0].totalPages);
                    setTotalCount(totalRecords);
                }
            }


            console.log("Graphic Leads", graphicDesigningLeads);
            setLeadsData(graphicDesigningLeads);
        } catch (err) {
            console.error("Error while fetching Graphic Designing Team:", err);
            toast.error("Failed to load Graphic Designing Team.");
        }
    };


    const getLeadsBasedOnService = async (role, roleType, serviceTeamType) => {
        const params = {
            role: role,
            roleType: roleType,
            serviceTeamType: serviceTeamType
        };

        try {
            const response = await getData("leads/assignedleads", params, sessionToken);
            console.log("Response:", response)

            const filteredLeads = response.data.filter(lead => lead.serviceTeamType === "Graphic Designing");

            console.log("Filtered Leads:", filteredLeads);
            setLeadsData(filteredLeads);

        } catch (err) {
            console.error("Error while fetching Graphic Design Team:", err);
            toast.error("Failed to load Graphic Design Team.");
        }
    };

    const getDailyUpdates = async () => {

        try {
            const response = await getData(`dailyworkupdates/user/${UserId}`, {}, sessionToken);
            console.log("Response Daily Updates:", response)
            const results = response?.data;
            console.log("Results:", results)
            setDailyData(results);

        } catch (err) {
            console.error("Error while fetching Graphic Designing Team:", err);
            toast.error("Failed to load Graphic Designing Team.");
        }

    }

    const getAllUpdatesAdmin = async () => {

        const params = {
            page: 1,
            limit: 1000
        }

        try {
            const response = await getData("dailyworkupdates/updates", params, sessionToken);
            console.log("Response Dailyyy Updates:", response)

            const filteredData = response?.data[0]?.paginatedResults?.filter(lead => lead.serviceName === "Graphic Designing");

            console.log("Filtered Data:", filteredData);
            setAllUpdates(filteredData); // Store all data here
            // setView(filteredData);

        } catch (err) {
            console.error("Error while fetching Graphic Designing Team:", err);
            toast.error("Failed to load Graphic Designing Team.");
        }

    }

    const handleFileChange = (event, leadId) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
            handleFileUpload(file, leadId);
        }
    };

    const handleFileUpload = async (fileupload) => {
        console.log("Fileupload:", fileupload);
        console.log("Is File:", fileupload instanceof File);

        const formDataToSend = new FormData();
        formDataToSend.append("file", fileupload);

        try {
            const response = await uploadFile(`files/upload/${selectedLeadId}`, formDataToSend);
            if (response?.status === 200) {
                toast.success("File uploaded successfully!");
                setFileUpload(response?.data);
                setFormData(prevState => ({
                    ...prevState,
                    fileupload: response?.data,
                }));
            } else {
                toast.error("File upload failed!");
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error("Error uploading file.");
        }
    };

    const postDailyUpdates = async () => {
        debugger
        try {
            // First check if updates exist for this lead
            const checkResponse = await getData(`dailyworkupdates/${selectedLeadId}`, {}, sessionToken);
            const existingUpdates = checkResponse?.data?.map(update => update?.graphicDesignHistory?.map(history => history?.dailyUpdateId)) || [];
            const graphicDesignHistory = selectedLead?.graphicDesignHistory?.[0] ||
                selectedLead?.graphicDesignHistory ||
                {};
            const assignedDesigns = selectedLead?.graphicDesignHistory?.[0]?.assignedDesigns;
            const previousCompleted = graphicDesignHistory.completedDesigns || 0;
            const newCompleted = parseInt(formData.completedDesigns, 10) || 0;
            const totalCompleted = previousCompleted + newCompleted;
            const remainingDesigns = assignedDesigns - newCompleted;

            // Get existing lead data or use defaults
            const designType = selectedLead?.graphicDesignHistory?.[0]?.designType ||
                selectedLead?.graphicDesignHistory?.designType ||
                '';
            const requirements = selectedLead?.graphicDesignHistory?.[0]?.requirements ||
                selectedLead?.graphicDesignHistory?.requirements ||
                '';
            const deadline = selectedLead?.graphicDesignHistory?.[0]?.deadline ||
                selectedLead?.graphicDesignHistory?.deadline ||
                '';
            const totalDesigns = selectedLead?.graphicDesignHistory?.[0]?.totalDesigns ||
                selectedLead?.graphicDesignHistory?.totalDesigns ||
                '';
            const amount = selectedLead?.graphicDesignHistory?.[0]?.amount ||
                selectedLead?.graphicDesignHistory?.amount ||
                '';
            const assignedTo = selectedLead?.graphicDesignHistory?.[0]?.assignedTo ||
                selectedLead?.graphicDesignHistory?.assignedTo ||
                '';
            const status = selectedLead?.graphicDesignHistory?.[0]?.completedDesigns === selectedLead?.graphicDesignHistory?.[0]?.totalDesigns ? "Completed" : "In Progress" || '';

            const payLoad = {
                designType,
                amount,
                assignedTo,
                requirements,
                colorScheme: formData.colorScheme,
                fileFormat: formData.fileFormat,
                assignedDesigns: remainingDesigns,
                deadline,
                status: status,
                fileUpload: fileUpload,
                comments: formData.comments,
                totalDesigns,
                completedDesigns: totalCompleted,
                serviceName: "Graphic Designing",
                leadId: selectedLeadId,
                userId: UserId,
            };

            let response;

            if (existingUpdates.length === 0) {
                // POST new update if none exists
                response = await postData('dailyworkupdates', payLoad, sessionToken);
            } else {
                // PUT update existing record
                const updateId = existingUpdates[0]; // Get first update's ID
                response = await putData(`dailyworkupdates/dailyworkupdates/${updateId}`, payLoad, sessionToken);
            }

            if (response?.status === 200) {
                toast.success("Daily Work Updated Successfully!");
                handleClose();

                // Refresh data based on user role
                if (roleType === "Employee") {
                    getDailyUpdates();
                }
                fetchAssignedLeads();

                // Reset form
                setFormData({
                    projectName: "",
                    designType: "",
                    colorScheme: "",
                    fileFormat: "",
                    requirements: "",
                    deadline: "",
                    status: "",
                    comments: "",
                    fileUpload: "",
                    completionPercentage: "",
                    totalDesigns: "",
                    completedDesigns: ""
                });
                setFileUpload(null);
            } else {
                throw new Error(response?.message || "Failed to update Daily Work.");
            }

        } catch (error) {
            console.error("Error:", error);
            toast.error(error.message || "Something went wrong. Please try again!");
        }
    };

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        if (currentPage === 1) {
            setLimit(event.target.value)
            fetchAssignedLeads(1, event.target.value)
        }
        else {
            setCurrentPage(1);
            setLimit(event.target.value);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            fetchAssignedLeads(currentPage - 1, limit);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
            fetchAssignedLeads(currentPage + 1, limit);
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    useEffect(() => {
        getAllUsers();
        getAllUpdatesAdmin();
        fetchAssignedLeads(currentPage, limit);
        if (roleType === "Employee") {
            getDailyUpdates();
        }
    }, [role, roleType, serviceTeamType, currentPage, limit]);

    return (
        <>
            <Helmet>
                <title>Service | Graphic Design</title>
            </Helmet>
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Graphic Design
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                        <Button
                            variant="outlined"
                            onClick={() => setViewMode(viewMode === 'table' ? 'chart' : 'table')}
                            sx={{ marginRight: 2 }}
                        >
                            {viewMode === 'table' ? 'View Chart' : 'View Table'}
                        </Button>
                    </Box>
                </Stack>
                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
                    {
                        viewMode === "chart" ? (
                            <Box sx={{ width: '100%', height: 400, padding: 2 }}>
                                {
                                    role === "Admin" || roleType === "Team Leader" ? (
                                        <ResponsiveContainer width="100%" height="90%">
                                            <BarChart
                                                data={leadsData.map(lead => ({
                                                    name: lead.name,
                                                    total: lead?.graphicDesignHistory?.totalDesigns || 0,
                                                    completed: lead?.graphicDesignHistory?.completedDesigns || 0,
                                                    pending: (lead?.graphicDesignHistory?.totalDesigns || 0) -
                                                        (lead?.graphicDesignHistory?.completedDesigns || 0)
                                                }))}
                                                margin={{
                                                    top: 5,
                                                    right: 30,
                                                    left: 20,
                                                    bottom: 5,
                                                }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="name" />
                                                <YAxis />
                                                <Tooltip />
                                                <Legend />
                                                <Bar dataKey="total" fill="#8884d8" name="Total Designs" />
                                                <Bar dataKey="completed" fill="#82ca9d" name="Completed Designs" />
                                                <Bar dataKey="pending" fill="#ffc658" name="Pending Designs" />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    ) : <ResponsiveContainer width="100%" height="90%">
                                        <BarChart
                                            data={leadsData.map(lead => ({
                                                name: lead.name,
                                                total: lead?.graphicDesignHistory[0]?.totalDesigns || 0,
                                                completed: lead?.graphicDesignHistory[0]?.completedDesigns || 0,
                                                pending: (lead?.graphicDesignHistory[0]?.totalDesigns || 0) -
                                                    (lead?.graphicDesignHistory[0]?.completedDesigns || 0)
                                            }))}
                                            margin={{
                                                top: 5,
                                                right: 30,
                                                left: 20,
                                                bottom: 5,
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="name" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <Bar dataKey="total" fill="#8884d8" name="Total Designs" />
                                            <Bar dataKey="completed" fill="#82ca9d" name="Completed Designs" />
                                            <Bar dataKey="pending" fill="#ffc658" name="Pending Designs" />
                                        </BarChart>
                                    </ResponsiveContainer>
                                }
                            </Box>
                        ) : (
                            <>
                                <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                                    {
                                        role === "Admin" || roleType === "Team Leader" ? (
                                            <Table>
                                                <TableHead>
                                                    <TableCell>S.No</TableCell>
                                                    {/* <TableCell>Assigned User</TableCell> */}
                                                    <TableCell>Lead Name</TableCell>
                                                    {/* <TableCell>Email</TableCell> */}
                                                    <TableCell>Phone</TableCell>
                                                    <TableCell>Project</TableCell>
                                                    <TableCell>Assigned Tasks</TableCell>
                                                    <TableCell>Completed Tasks</TableCell>
                                                    <TableCell>File</TableCell>
                                                    <TableCell>Status</TableCell>
                                                    <TableCell></TableCell>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        leadsData.length === 0 ? (
                                                            <TableRow>
                                                                <TableCell colSpan={7} align="center">
                                                                    No data found
                                                                </TableCell>
                                                            </TableRow>
                                                        ) : (
                                                            leadsData?.map((task, id) => {
                                                                return (
                                                                    <TableRow key={task?.id}>
                                                                        <TableCell>{calculateIndex(id)}</TableCell>
                                                                        {/* <TableCell>{task?.assignedTo?.name || task.name}</TableCell> */}
                                                                        <TableCell>{task?.name}</TableCell>
                                                                        {/* <TableCell>{task?.email}</TableCell> */}
                                                                        <TableCell>{task?.phone}</TableCell>
                                                                        <TableCell>{task?.graphicDesignHistory?.projectName}</TableCell>
                                                                        <TableCell>{task?.graphicDesignHistory?.assignedDesigns}</TableCell>
                                                                        <TableCell>{task?.graphicDesignHistory?.completedDesigns ? task?.graphicDesignHistory?.completedDesigns : "0"} / {task?.graphicDesignHistory?.totalDesigns}</TableCell>
                                                                        <TableCell>
                                                                            {task?.graphicDesignHistory?.fileUpload?.path ?
                                                                                <img
                                                                                    src={task?.graphicDesignHistory?.fileUpload?.path
                                                                                        ? `${file_URL + encodeURI(task?.graphicDesignHistory?.fileUpload?.path.replace("public/", ""))}`
                                                                                        : "#"}
                                                                                    alt=''
                                                                                    style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                                    onClick={() => {
                                                                                        const fullImage = task?.graphicDesignHistory?.fileUpload?.path
                                                                                            ? `${file_URL + encodeURI(task?.graphicDesignHistory?.fileUpload?.path.replace("public/", ""))}`
                                                                                            : "#";
                                                                                        setSelectedImage(fullImage);
                                                                                        setOpenImage(true);
                                                                                    }}
                                                                                />
                                                                                : "-"}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Box position="relative" display="inline-flex">
                                                                                <CircularProgress
                                                                                    variant="determinate"
                                                                                    value={task?.graphicDesignHistory?.completionPercentage}
                                                                                />
                                                                                <Box
                                                                                    top={0}
                                                                                    left={0}
                                                                                    bottom={0}
                                                                                    right={0}
                                                                                    position="absolute"
                                                                                    display="flex"
                                                                                    alignItems="center"
                                                                                    justifyContent="center"
                                                                                >
                                                                                    <Typography variant="caption" component="div" color="text.secondary">
                                                                                        {typeof task?.graphicDesignHistory?.completionPercentage === 'number'
                                                                                            ? `${Math.round(task.graphicDesignHistory.completionPercentage)}%`
                                                                                            : '0%'}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Iconify
                                                                                icon="material-symbols-light:more-vert"
                                                                                sx={{ margin: "auto" }}
                                                                                onClick={(event) => handleOpenMenu(event, task, task._id, task.graphicDesignHistory?.dailyUpdateId)}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })
                                                        )
                                                    }
                                                </TableBody>
                                            </Table>
                                        ) : roleType === "Employee" ? (
                                            <Table>
                                                <TableHead>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>Name</TableCell>
                                                    <TableCell>Contact</TableCell>
                                                    <TableCell>Assigned Work</TableCell>
                                                    <TableCell>Assigned Pages</TableCell>
                                                    <TableCell>Deadline</TableCell>
                                                    <TableCell>Completed Pages</TableCell>
                                                    <TableCell>File</TableCell>
                                                    {/* <TableCell>Design Type</TableCell> */}
                                                    <TableCell>Progress</TableCell>
                                                    <TableCell></TableCell>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        leadsData?.length === 0 ? (
                                                            <TableRow>
                                                                <TableCell colSpan={7} align="center">
                                                                    No data found
                                                                </TableCell>
                                                            </TableRow>
                                                        ) : (
                                                            leadsData?.map((work, id) => {
                                                                return (
                                                                    <TableRow key={work?.id}>
                                                                        <TableCell>{calculateIndex(id)}</TableCell>
                                                                        <TableCell>{work?.name}</TableCell>
                                                                        <TableCell>{work?.phone}</TableCell>
                                                                        <TableCell>{work?.currentWork?.noOfPosters}</TableCell>
                                                                        <TableCell>{work?.currentWork?.comments}</TableCell>
                                                                        <TableCell>{work?.currentWork !== null ? new Date(work?.currentWork?.deadline).toLocaleDateString() : "-"}</TableCell>
                                                                        <TableCell>{work?.graphicDesignHistory[0]?.completedDesigns} / {work?.graphicDesignHistory[0]?.totalDesigns}</TableCell>
                                                                        <TableCell>
                                                                            <img
                                                                                src={work?.graphicDesignHistory[0]?.fileUpload?.path
                                                                                    ? `${file_URL + encodeURI(work?.graphicDesignHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                                    : "#"}
                                                                                alt=''
                                                                                style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                                onClick={() => {
                                                                                    const fullImage = work?.graphicDesignHistory[0]?.fileUpload?.path
                                                                                        ? `${file_URL + encodeURI(work?.graphicDesignHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                                        : "#";
                                                                                    setSelectedImage(fullImage);
                                                                                    setOpenImage(true);
                                                                                }}
                                                                            />
                                                                        </TableCell>
                                                                        {/* <TableCell>{work?.graphicDesignHistory[0]?.designType}</TableCell> */}
                                                                        <TableCell align="center">
                                                                            <Box position="relative" display="inline-flex">
                                                                                <CircularProgress
                                                                                    variant="determinate"
                                                                                    value={work?.graphicDesignHistory[0]?.completionPercentage}
                                                                                />
                                                                                <Box
                                                                                    top={0}
                                                                                    left={0}
                                                                                    bottom={0}
                                                                                    right={0}
                                                                                    position="absolute"
                                                                                    display="flex"
                                                                                    alignItems="center"
                                                                                    justifyContent="center"
                                                                                >
                                                                                    <Typography variant="caption" component="div" color="text.secondary">
                                                                                        {typeof work?.graphicDesignHistory[0]?.completionPercentage === 'number'
                                                                                            ? `${Math.round(work.graphicDesignHistory[0].completionPercentage)}%`
                                                                                            : '0%'}
                                                                                    </Typography>

                                                                                </Box>
                                                                            </Box>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Iconify
                                                                                icon="material-symbols-light:more-vert"
                                                                                sx={{ margin: "auto" }}
                                                                                onClick={(event) => {
                                                                                    console.log('Work object:', work);
                                                                                    handleOpenMenu(event, work, work._id, work?.graphicDesignHistory[0]?.dailyUpdateId);
                                                                                }}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })
                                                        )
                                                    }
                                                </TableBody>
                                            </Table>
                                        ) : null
                                    }
                                </TableContainer>
                                <PaginationComponent
                                    name={"Leads"}
                                    totalcount={totalCount}
                                    limit={limit}
                                    handleLimitChange={handleLimitChange}
                                    handlePrevPage={handlePrevPage}
                                    handleNextPage={handleNextPage}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                />
                            </>
                        )
                    }
                </Card>

                {/* Dialog Event  */}
                <Dialog open={formOpen} onClose={() => setFormOpen(false)}>
                    <DialogTitle>Daily Work Update</DialogTitle>
                    <DialogContent>
                        {/* <TextField
                            margin="dense"
                            label="Status"
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                            select
                            fullWidth
                        >
                            <MenuItem value="Pending">Pending</MenuItem>
                            <MenuItem value="In Progress">In Progress</MenuItem>
                            <MenuItem value="Completed">Completed</MenuItem>
                        </TextField> */}
                        <TextField
                            margin="dense"
                            label="Comments"
                            name="comments"
                            value={formData.comments}
                            onChange={handleChange}
                            fullWidth
                        />
                        <TextField
                            margin='dense'
                            type='file'
                            hidden
                            label="Upload File"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleFileChange(e)}
                        >
                        </TextField>
                        <TextField
                            margin="dense"
                            label="Completed Designs"
                            name="completedDesigns"
                            type="number"
                            value={formData.completedDesigns}
                            onChange={handleChange}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setFormOpen(false)} color="secondary">Cancel</Button>
                        <Button color="primary" onClick={postDailyUpdates}>Update</Button>
                    </DialogActions>
                </Dialog>

                {/* Edit Menu  */}
                <Popover
                    open={Boolean(open)}
                    anchorEl={open}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    {
                        role === "Admin" ? (
                            <MenuItem onClick={handleOpenDialog}>
                                <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                                View
                            </MenuItem>
                        ) : roleType === "Team Leader" ? (
                            <>
                                <MenuItem onClick={handleOpenDialog}>
                                    <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                                    View
                                </MenuItem>
                                <MenuItem onClick={handleFormOpen}>
                                    <Iconify icon="material-symbols:sync-alt" sx={{ mr: 2 }} />
                                    Convert
                                </MenuItem>
                                {/* <MenuItem onClick={handleOpen}>
                                    <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                                    Work Update
                                </MenuItem> */}
                            </>
                        ) : (
                            <>
                                <MenuItem onClick={handleOpen}>
                                    <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                                    Work Update
                                </MenuItem>

                                <MenuItem sx={{ color: 'error.main' }}>
                                    <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                                    Delete
                                </MenuItem>
                            </>
                        )
                    }
                    {/* {
                        role === "Admin" ? (
                            <MenuItem onClick={handleOpenDialog}>
                                <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                                View
                            </MenuItem>
                        ) : roleType === "Team Leader" ? (
                            <MenuItem onClick={handleFormOpen}>
                                Convert
                            </MenuItem>
                        ) : (
                            <>
                                <MenuItem onClick={handleOpen}>
                                    <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                                    Work Update
                                </MenuItem>

                                <MenuItem sx={{ color: 'error.main' }}>
                                    <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                                    Delete
                                </MenuItem>
                            </>
                        )
                    } */}
                </Popover >

                <Dialog open={openImage} onClose={() => setOpenImage(false)} maxWidth="md">
                    <Iconify
                        icon="material-symbols:close"
                        onClick={() => setOpenImage(false)}
                        style={{
                            position: 'absolute',
                            top: 10,
                            right: 10,
                            fontSize: 24,
                            cursor: 'pointer',
                            zIndex: 1
                        }}
                    />
                    <DialogContent>
                        <img src={selectedImage} alt="Full View" style={{ width: "100%", height: "auto" }} />
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={details}
                    onClose={handleCloseDialog}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                            Daily Work Updates
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            component="div"
                        >
                            {!view || Object.keys(view).length === 0 ? (
                                <Box sx={{ p: 3, textAlign: 'center' }}>
                                    <Typography variant="h6" color="text.secondary">No data found</Typography>
                                </Box>
                            ) : (
                                <Box sx={{ p: 1 }}>
                                    <Paper elevation={3} sx={{
                                        p: 2,
                                        backgroundColor: '#ffffff',
                                        borderRadius: 2,
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                        borderLeft: '5px solid #1976d2' // A subtle accent line
                                    }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Project Details
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Name: {view?.name}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Design Type: {view?.graphicDesignHistory?.designType}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Deadline: {new Date(view?.graphicDesignHistory?.deadline).toLocaleDateString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Status: <Typography component="span" sx={{
                                                        fontWeight: 'bold',
                                                        color: view?.graphicDesignHistory?.status === 'Completed' ? 'success.main' :
                                                            view?.graphicDesignHistory?.status === 'In Progress' ? 'warning.main' : 'error.main'
                                                    }}>
                                                        {view?.graphicDesignHistory?.status}
                                                    </Typography>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    requirements: {view?.graphicDesignHistory?.requirements}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Task Progress
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Completed Designs: {view?.graphicDesignHistory?.completedDesigns}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Total Designs: {view?.graphicDesignHistory?.totalDesigns}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="body1">
                                                    Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                        {view?.graphicDesignHistory?.completionPercentage}%
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            {view?.[0]?.graphicDesignHistory?.comments && (
                                                <Grid item xs={12} id="paddingTop">
                                                    <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#333' }}>
                                                        Comments
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                                                        {view?.[0]?.graphicDesignHistory?.comments}
                                                    </Typography>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Timestamps
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Created: {new Date(view?.createdAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Updated: {new Date(view?.updatedAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Box>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog}>Close</Button>
                    </DialogActions>
                </Dialog>

                {/* Convert leads */}
                <Dialog open={convertForm}>
                    <DialogTitle>Convert Leads</DialogTitle>
                    <DialogContent>
                        <FormControl fullWidth margin="dense">
                            <InputLabel id="assign-to-label">Assign To</InputLabel>
                            <Select
                                labelId="assign-to-label"
                                multiple
                                value={convertData.assignedTo}
                                onChange={handleMultiSelectChange}
                                InputLabelProps={{ shrink: true }}
                                label="Assign To"
                                input={<OutlinedInput label="Assign To" />}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => {
                                            const employee = employeeOptions.find(emp => emp.id === value);
                                            return employee ? (
                                                <Chip key={value} label={employee.name} />
                                            ) : null;
                                        })}
                                    </Box>
                                )}
                                fullWidth
                            >
                                {employeeOptions.map((emp) => (
                                    <MenuItem key={emp.id} value={emp.id}>
                                        {emp.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Box sx={{ mt: 2 }}>
                            {convertData.assignedTo.map((empId) => {
                                const employee = employeeOptions.find(emp => emp.id === empId);
                                return (
                                    <>
                                        <Box key={empId} sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 2 }}>
                                            <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                                                <div className='col' style={{ marginTop: "5px" }}>
                                                    <Typography>{employee?.name}</Typography>
                                                </div>
                                            </div>
                                        </Box>
                                        <Box key={empId} sx={{ alignItems: 'center', mb: 1, gap: 2 }}>
                                            <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "10px" }}>
                                                <TextField
                                                    label="Comments"
                                                    value={convertData.employeeWork?.[empId]?.comments || ""}
                                                    onChange={(e) => {
                                                        const work = e.target.value;
                                                        setConvertData(prev => ({
                                                            ...prev,
                                                            employeeWork: {
                                                                ...prev.employeeWork,
                                                                [empId]: {
                                                                    ...prev.employeeWork?.[empId],
                                                                    comments: work
                                                                }
                                                            }
                                                        }));
                                                    }}
                                                    size="small"
                                                    fullWidth
                                                />
                                                <TextField
                                                    label="No of Posters"
                                                    value={convertData.employeeWork?.[empId]?.noOfPosters || ""}
                                                    onChange={(e) => {
                                                        const work = e.target.value;
                                                        setConvertData(prev => ({
                                                            ...prev,
                                                            employeeWork: {
                                                                ...prev.employeeWork,
                                                                [empId]: {
                                                                    ...prev.employeeWork?.[empId],
                                                                    noOfPosters: work
                                                                }
                                                            }
                                                        }));
                                                    }}
                                                    size="small"
                                                    fullWidth
                                                />
                                                <TextField
                                                    label="Deadline"
                                                    value={convertData.employeeWork?.[empId]?.deadline || ""}
                                                    onChange={(e) => {
                                                        const work = e.target.value;
                                                        setConvertData(prev => ({
                                                            ...prev,
                                                            employeeWork: {
                                                                ...prev.employeeWork,
                                                                [empId]: {
                                                                    ...prev.employeeWork?.[empId],
                                                                    deadline: work
                                                                }
                                                            }
                                                        }));
                                                    }}
                                                    type='date'
                                                    size="small"
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </div>
                                            {/* <div style={{ display: "flex", justifyContent: "start", gap: "20px" }}>
                                                <FormControl fullWidth size="small" style={{ maxWidth: "265px", width: "100%" }}>
                                                    <InputLabel>Status</InputLabel>
                                                    <Select
                                                        value={convertData.employeeWork?.[empId]?.status || ""}
                                                        label="Status"
                                                        onChange={(e) => {
                                                            const work = e.target.value;
                                                            setConvertData(prev => ({
                                                                ...prev,
                                                                employeeWork: {
                                                                    ...prev.employeeWork,
                                                                    [empId]: {
                                                                        ...prev.employeeWork?.[empId],
                                                                        status: work
                                                                    }
                                                                }
                                                            }));
                                                        }}
                                                    >
                                                        <MenuItem value="Pending">Pending</MenuItem>
                                                        <MenuItem value="Completed">Completed</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div> */}
                                        </Box>
                                    </>
                                );
                            })}
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleFormClose} color="secondary">Cancel</Button>
                        <Button onClick={convertLeads} color="primary">Submit</Button>
                    </DialogActions>
                </Dialog>

            </Container >
        </>
    )
}

export default GraphicDesign
